module.exports = __webpack_public_path__ + "img/artpalet.64701bc8.png";